import BannerComponent from '../components/BannerComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import React from 'react';
import moment from 'moment';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import InputCalendarComponent from '../components/inputs/InputCalendarComponent';
import TooltipComponent from '../components/TooltipComponent';
import MenuItemIcon from '../components/MenuItemIcon';

export const AnwimLpgDeliveryContainer = (props) => {
    const {
        t,
        summaryPage,
        element,
        validator,
        agreementEmail,
        deliveryPlaces,
        handleChange,
        orderTypeOptions,
        handleHideTooltip,
        handleShowTooltip,
        handleShowTooltipMenuItem,
        onTooltipClick,
        sentNumberTooltipVisibile,
        templateEdit,
    } = props;
    return (
        <React.Fragment>
            <div className={`row ${summaryPage ? '' : ''}`}>
                <InputDropdownComponent
                    id='orderType-dropdown'
                    name='orderType'
                    label={summaryPage ? t('order-fuel.deliveryReception') : t('order-fuel.orderType')}
                    colClass='col-md-4 col-sm-12'
                    value={element.orderType}
                    viewMode={summaryPage ? 'VIEW' : 'EDIT'}
                    validator={validator}
                    validators='required'
                    options={orderTypeOptions}
                    onChange={handleChange}
                    optionLabel='label'
                    enumMode
                    enumName='OrderType'
                    optionValue='enumValue'
                    dataKey='enumValue'
                    disabled
                    renderValue={
                        summaryPage
                            ? () => {
                                  return element.orderType ? (
                                      <label className='black-labels'>{t(`OrderType.${element.orderType}`)}</label>
                                  ) : (
                                      <label />
                                  );
                              }
                            : null
                    }
                />
                {templateEdit ? null :
                    <InputCalendarComponent
                    id='deliveryDate'
                    name='deliveryDate'
                    label={t('order-fuel.deliveryDate')}
                    dateFormatMoment='DD-MM-YYYY'
                    colClass='col-md-4 calendar-icon-white-bg'
                    value={element.deliveryDate}
                    validator={validator}
                    validators={`required|date|date_format:DD-MM-YYYY,dd-mm-rrrr|after_or_equal:${moment(new Date()).format(
                        'DD-MM-YYYY'
                    )}|`}
                    onChange={handleChange}
                    showIcon
                    minDate={new Date()}
                    viewMode={summaryPage ? 'VIEW' : 'EDIT'}
                    renderValue={
                        summaryPage
                            ? () => {
                                  return element.deliveryDate ? (
                                      <React.Fragment>
                                          <label className='black-labels flex-inputs'>
                                              {moment(element.deliveryDate).format('DD-MM-YYYY')}
                                          </label>
                                          <label className='white-labels flex-inputs'>
                                              {t(`weekDays.${element.deliveryDate.getDay()}`)}
                                          </label>
                                      </React.Fragment>
                                  ) : (
                                      <label />
                                  );
                              }
                            : null
                    }
                />}
                <InputTextComponent
                    id='email'
                    name='email'
                    label={t('order-fuel.sentKeyEmail')}
                    colClass='col-md-4 col-sm-12'
                    value={agreementEmail}
                    viewMode={summaryPage ? 'VIEW' : 'EDIT'}
                    validator={validator}
                    validators='required'
                    onChange={handleChange}
                    disabled
                    renderValue={
                        summaryPage
                            ? () => {
                                  return agreementEmail ? <label className='white-labels'>{agreementEmail}</label> : <label />;
                              }
                            : null
                    }
                    renderLabel={() => (
                        <div className='tooltip-label'>
                            <TooltipComponent
                                id='sentKeyEmail-tooltip-label-id'
                                key='sentKeyEmail-tooltip-label-id'
                                onClick={onTooltipClick}
                                visible={sentNumberTooltipVisibile}
                                content={t('order-fuel.sentNumberTooltip')}
                                eventListeners={[
                                    {
                                        eventName: 'mouseleave',
                                        fnc: handleHideTooltip,
                                        eventElementId: 'ico_help_input_label_id',
                                    },
                                    {
                                        eventName: 'mouseenter',
                                        fnc: handleShowTooltip,
                                        eventElementId: 'ico_help_input_label_id',
                                    },
                                ]}
                            />
                            <span className='row '>
                                <label id='sentKeyEmail-label-id' className='p-label flex-inputs ' htmlFor={'sentKeyEmail-label-id'}>
                                    {t('order-fuel.sentKeyEmail')}
                                </label>
                                <MenuItemIcon
                                    alt=''
                                    key={'menu-item-key'}
                                    id='ico_help_input_label_id'
                                    className='icon-svg right-label flex-inputs'
                                    iconSvg={'ico_help_input_label'}
                                    eventListeners={[
                                        {
                                            eventName: 'mouseenter',
                                            fnc: handleShowTooltipMenuItem,
                                            eventElementId: 'ico_help_input_label_id',
                                        },
                                    ]}
                                ></MenuItemIcon>
                            </span>
                        </div>
                    )}
                />
            </div>
            {!!element.adBlueLpg ? (
                <div className='row fleet-good-group-banner-lpg'>
                    <BannerComponent
                        label={t('order-fuel.adBlueLpgDeliveryDateInfoBannerText')}
                        iconSvg='ico_blue_banner_icon'
                        iconSide='left'
                    />
                </div>
            ) : null}
            <div className='row'>
                <InputDropdownComponent
                    id='partner'
                    name='partner'
                    label={t('order-fuel.partner')}
                    colClass='col-md-8 col-sm-12 '
                    value={element.partner}
                    viewMode={summaryPage ? 'VIEW' : 'EDIT'}
                    validator={validator}
                    validators='required'
                    options={deliveryPlaces}
                    onChange={handleChange}
                    dataKey='sapId'
                    optionLabel='address'
                    oprionValue='address'
                    renderValue={
                        summaryPage
                            ? () => {
                                  return element.partner && element.partner['address'] ? (
                                      <label className='black-labels'>{element.partner['address']}</label>
                                  ) : (
                                      <label />
                                  );
                              }
                            : null
                    }
                />
            </div>
        </React.Fragment>
    );
};
